// extracted by mini-css-extract-plugin
module.exports = {"bodyColor":"d_F","body":"f_T d_F"};